import React from 'react';
import { string, shape, bool } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { createSourceInfo } from '../../../../../shared/utils/bi';
import { BI_CONSTS } from '../../../utils/constants';
import ExplanationVideo from '../../../../../shared/components/ExplanationVideo';
import './index.scss';

const SubcatHeader = ({ data }) => {

    const {
        title,
        hasVideoLink,
        video,
        scName
    } = data;

    const sourceInfo = createSourceInfo({
        videoName: video.name,
        mixpanelPageName: BI_CONSTS.MIXPANEL_PAGE_NAME,
        bigQueryPageName: BI_CONSTS.BIGQUERY_PAGE_NAME
    });

    const videoTitle = hasVideoLink ? <I18n k="shared.explanation_video.title" params={{ scName }}/> : <I18n k="shared.how_fiverr_works"/>;

    return (
        <header className="subcategory-header">
            <div className="title-wrapper">
                <h1>{title}</h1>
            </div>
            {<ExplanationVideo hasVideoLink={hasVideoLink}
                subcat={data}
                video={video}
                videoTitle={videoTitle}
                sourceInfo={sourceInfo}/>}
        </header>
    );
};

SubcatHeader.propTypes = {
    data: shape({
        title: string,
        subtitle: string,
        video: shape({
            id: string,
            name: string,
            src: string
        }),
        hasVideoLink: bool
    })
};

export default SubcatHeader;
